export default "__VITE_ASSET__DHm0in8o__"